//Products FlexiGrid


/*

	UpdatedByUserID - Not currently supported
	CreatedByUserID - Not currently supported
	RestoredBool - Not currently supported
	RestoredFromDate - Not currently supported
	DeletedByUserID - Not currently supported

*/

//React & Friends
import React, { useState, useEffect, useContext, useRef } from 'react';
import FlexiGrid from '../common/FlexiGrid/FlexiGrid';

//Doublecheck everything below this line. All from old boilerplate table.
import { useLocation, useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

//Contexts
import { AppContext } from "../Auth/contexts/AppContext"

//CSS Styles
//import { useTheme } from '@mui/material/styles'; //Only if needed. Access theme variables with: const theme = useTheme(); Add custom properties to theme in ui/theme/index.js.
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';

//Datetime formatting
import dayjs from 'dayjs'; //Used with new datetimepickers

//MaterialUI
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

//Icons for Custom Buttons:
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Select } from '@mui/material';

//NNNNNNNNNNNNN-NON-STANDARD IMPORTS-SSSSSS-SSS
//Additional Libraries Specific to XYZ FlexiGrid goes below this line. Just so long as FlexiGrid and the above are being kept tidy, we're in good shape.
import ViewListIcon from '@mui/icons-material/ViewList';


var hostbase = process.env.REACT_APP_BASE;

//Functional Controller
const ProductsFlexiGrid = () => {
	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	/* App Context - Allows userPerms, userRole, and others to be used*/
	const appContext = useContext(AppContext);
	const { userPerms, userRole } = appContext;

	/* ##########################  DATA MUTATION  ########################## */
	//   This function allows us to mutate data after it is received from the database, but before it is rendered on the grid or exported.
	const MutateData = (dbdata) => {
		//Mutate each item in dbdata as needed.
		for (var i=0; i<dbdata.length; i++){
			//Example: Add Margin calculation
			dbdata[i]["NewMargin"] = (parseFloat(dbdata[i]["Price"]) - parseFloat(dbdata[i]["Cost"])).toFixed(2);
		}
		return dbdata;
	}
	//An example of mutation specifically for exports. This allows you to have different data shown on screen vs exported.
	const ExportMutateData = (dbdata) => {
		//Mutate each item in dbdata as needed.
		for (var i=0; i<dbdata.length; i++){
			//Example: Add Margin calculation
			dbdata[i]["NewNewMargin"] = (parseFloat(dbdata[i]["Price"]) - parseFloat(dbdata[i]["Cost"])+500).toFixed(2);
		}
		return dbdata;
	}


	/* ##########################  EXPANDED ROW RENDER  ########################## */
	//   This controls how a bonus row is rendered on ExpandRow! Enable bonus row with configuration.expandedrow = true.
	const ExpandedRowRender = ({ localstate, index, classes, UpdateState }) => {
		//console.log(localstate);
		//Bonus row is rendered just inside <tr><tr>
		//With access to index, localstate, and UpdateState, you can make this to powerful things!
		return (
			<td colSpan={localstate.configuration.columns.filter(col=>col.visible).length} style={{ backgroundColor: "#F9F9F9", borderTop: "0px", padding: "10px 15px 10px 15px" }}>
				Full Width Example. 
			</td>
		)
	}

	/* ##########################  CUSTOM FUNCTIONS  ########################## */
	const CustomPriceRender = ({ localstate, index, column, classes, UpdateState, ExpandRowToggle }) => {
		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridcustomcontainer}
			>
				<span style={{ fontWeight: "bold", color: "blue" }} onClick={() => ExpandRowToggle(index)}>
					{localstate.griditems[index]["Price"]}
				</span>
			</td>
		);
	}; 

	const BulkMutatorBtn = ({ localstate, index, column, classes, UpdateState }) => {
		const ApplyBulkMutation = (localstate, UpdateState) => {
			for (var i=0; i<localstate.griditems.length; i++){
				localstate.griditems[i].Price = 666; //Or do some calculation based the current griditems values. 
			}
			UpdateState(localstate);
		}
		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridcustomcontainer}
			> 
				<span style={{ fontWeight: "bold", color: "blue" }}>
					<Button
						className={classes.bluebtn}
						style={{ margin: "0px", padding: "1px 1px 1px 1px", fontSize:"10px" }}
						color="primary" variant="contained"
						onClick={() => ApplyBulkMutation(localstate, UpdateState)}>
						Bulk Mutate Price
					</Button>
				</span>
			</td>
		);
	}; 


	
	const Grades = ({ localstate, index, column, classes, UpdateState }) => { 
		const ApplyBulkMutation = (localstate, UpdateState) => {
			for (var i=0; i<localstate.griditems.length; i++){
				localstate.griditems[i].Price = 666; //Or do some calculation based the current griditems values. 
			}
			UpdateState(localstate);
		}

		const barStyle = {
			height: "29px",
			display: "inline-block",
			overflow: "hidden",
			textOverflow: "hidden",
			whiteSpace: "nowrap", // Prevents text from wrapping to next line
			fontSize:"10px",
			color:"#000",
			//paddingLeft:"2px",
			//paddingRight:"2px", 
		};

		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridcustomcontainer}
			>
				<div style={{ width: "100%", height: "29px", display: "flex", flexWrap: "nowrap" }}>
					<div style={{ ...barStyle, width: (localstate.griditems[index].GradeAPct + "%"), backgroundColor: "#249a00" }}>
						<div style={{ padding: "2px" }}>
							{localstate.griditems[index].GradeAPct > 5 ? localstate.griditems[index].GradeACount : ""}
						</div>
					</div>
					<div style={{ ...barStyle, width: (localstate.griditems[index].GradeBPct + "%"), backgroundColor: "#ccff00" }}>
						<div style={{ padding: "2px" }}>
							{localstate.griditems[index].GradeBPct > 5 ? localstate.griditems[index].GradeBCount : ""}
						</div>
					</div>
					<div style={{ ...barStyle, width: (localstate.griditems[index].GradeCPct + "%"), backgroundColor: "#fff600" }}>
						<div style={{ padding: "2px" }}>
							{localstate.griditems[index].GradeCPct > 5 ? localstate.griditems[index].GradeCCount : ""}
						</div>
					</div>
					<div style={{ ...barStyle, width: (localstate.griditems[index].GradeRepairPct + "%"), backgroundColor: "#ffd200" }}>
						<div style={{ padding: "2px" }}>
							{localstate.griditems[index].GradeRepairPct > 5 ? localstate.griditems[index].GradeRepairCount : ""}
						</div>
					</div>
					<div style={{ ...barStyle, width: (localstate.griditems[index].GradeScrapPct + "%"), backgroundColor: "#ff0000" }}>
						<div style={{ padding: "2px" }}>
							{localstate.griditems[index].GradeScrapPct > 5 ? localstate.griditems[index].GradeScrapCount : ""}
						</div>
					</div>
					<div style={{ ...barStyle, width: (localstate.griditems[index].GradeUnknownPct + "%"), backgroundColor: "#c6c6c6" }}>
						<div style={{ padding: "2px" }}>
							{localstate.griditems[index].GradeUnknownPct > 5 ? localstate.griditems[index].GradeUnknownCount : ""}
						</div>
					</div>
				</div>
			</td>
		);
	}; 

	const NavInventory = ({ localstate, index, column, classes, UpdateState }) => {
		// const ApplyBulkMutation = (localstate, UpdateState) => {
		// 	for (var i=0; i<localstate.griditems.length; i++){
		// 		localstate.griditems[i].Price = 666; //Or do some calculation based the current griditems values. 
		// 	}
		// 	UpdateState(localstate);
		// }
		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridcustomcontainer}
			> 
				<a href={hostbase + "/inventorymanager?ProductID=" + encodeURIComponent(localstate.griditems[index].ProductID)+"&ProductName="+encodeURIComponent(localstate.griditems[index].Name)} target="_blank"> 
					<ViewListIcon className={classes.transparenticon} color="primary" fontSize="medium">
					</ViewListIcon>
				</a>
			</td>
		);
	}; 

	const DefaultComponents = ({ localstate, index, column, classes, UpdateState }) => {
		return (
			<td
				style={column.cellstyle}
				className={classes.flexigridcustomcontainer}
			>
				<div style={{ paddingBottom: "2px" }}>
					{localstate.griditems[index].productcomponents.map((component, componentindex) => {
						return (
							<div key={componentindex} className={classes.productcomponent} title={component.details.Cost}>
								{component.details.Name}
							</div>
						)
					})}
				</div>

			</td>
		);
	}; 


	const SelectSomeBoolean = ({localstate, UpdateState}) =>{
		for (var i=0; i<localstate.griditems.length; i++){
			if (localstate.griditems[i].SomeBoolean===0 && localstate.griditems[i].isSelected!==true){
				//Select the Row:
				localstate.selectedindexes.push(i);
				//And another demo of select the checkbox inside the row!
				localstate.griditems[i].SomeBoolean = 1;
				localstate.griditems[i].isSelected = true;
				UpdateState(localstate);
			}
		}
	}


	/* ##########################  CUSTOM ON-CHANGE FUNCTIONS  ########################## */
	//   Custom for onChange of items in edit mode. See reference to this function in the Cost column. Bear in mind, Cost itself is handled with validation positivedecimal2
	const onChangeCost = ({localstate, index, column, rowRefs}) => {
		rowRefs.current[index+"Margin"].textContent = localstate.griditems[index]["Margin"] = (parseFloat(localstate.griditems[index]["Price"]) - parseFloat(localstate.griditems[index]["Cost"])).toFixed(2);
	}

	/* ##########################  SEARCH INPUT DEFAULTS  ########################## */
	//   These establish the baseline for the page search inputs.
	//   Container and Key Sizes for Search Inputs
	const containersizes = "260px";
	const keysizes = "180px";

	//  Make sure to update defaultselectinputs as well to use your inputs. Named properties of inputdefaults must match to a 'value' in defaultselectinputs or else the input text will not render correctly.
	var inputdefaults = {  
		Name: {
			type: "Name",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		SkuPrefix: {
			type: "SkuPrefix",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		Mfg: {
			type: "Mfg",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		ProductType: {
			type: "ProductType",
			value: "",
			mode: "like",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1, //Allows input to grow with typed input?!
		},
		Touchscreen: {
			type: "Touchscreen",
			value: "",
			mode: "bool",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'TotalInventoryUnits >': {
			type: "TotalInventoryUnits >",
			value: "",
			mode: "greaterthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'TotalInventoryUnits <': {
			type: "TotalInventoryUnits <",
			value: "",
			mode: "lessthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'AverageCostActual >': {
			type: "AverageCostActual >",
			value: "",
			mode: "greaterthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'AverageCostActual <': {
			type: "AverageCostActual <",
			value: "",
			mode: "lessthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'TotalInventoryCost >': {
			type: "TotalInventoryCost >",
			value: "",
			mode: "greaterthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'TotalInventoryCost <': {
			type: "TotalInventoryCost <",
			value: "",
			mode: "lessthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'AverageAgeDays >': {
			type: "AverageAgeDays >",
			value: "",
			mode: "greaterthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'AverageAgeDays <': {
			type: "AverageAgeDays <",
			value: "",
			mode: "lessthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'StockOutDays30 >': {
			type: "StockOutDays30 >",
			value: "",
			mode: "greaterthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		'StockOutDays30 <': {
			type: "StockOutDays30 <",
			value: "",
			mode: "lessthan",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		//Would like, but not really necessary
		// components: {
		// 	type: "components",
		// 	keyedby: "ID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection
		// 	searchkey: "Name", //This is the column we are searching from the table
		// 	producttype: "",
		// 	value: [],
		// 	mode: "autocomplete",
		// 	orable: true,
		// 	defaultsearchterm: "",
		// 	limit: 10, //Database return limit, keep below ~100
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		RunDailyStats: {
			type: "RunDailyStats",
			value: "",
			mode: "bool",
			orable: false,
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			grow: 1,
		},
		Status: {
			type: "Status",
			value: [],
			mode: "select",
			orable: true,
			//Select Menu Items:
			menuitems: [
				{
					value: "Unknown",
					key: uuidv4(),
					text: "Unknown",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Unknown",
					chipclass: classes.gradebad, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: "Stalled",
					key: uuidv4(),
					text: "Stalled",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Stalled",
					chipclass: classes.graderepair, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: "Needs Work",
					key: uuidv4(),
					text: "Needs Work",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Needs Work",
					chipclass: classes.gradec, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: "OK",
					key: uuidv4(),
					text: "OK",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "OK",
					chipclass: classes.gradea, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
				{
					value: "Closeout \ Sold Out",
					key: uuidv4(),
					text: "Closeout \ Sold Out",
					//Optional usechip - Overrides text
					usechip: true,
					chipsize: "small",
					chiplabel: "Closeout \ Sold Out",
					chipclass: classes.gradeb, //Test this.		
					//Optional Chip Height and Centering:
					height: "22px",
					center: true,
				},
			],
			uuid: uuidv4(),
			container: containersizes,
			keysize: keysizes,
			//Experimental Multiple!
			multiple: true,//Change 'value' to array if true.
			center: true,
			grow: 1,
			usechips: true
		},


		// //Products AutoComplete - Autocompletes are always or-able
		// //For this demo, ProductID is a direct column on the basictable. However a lot of tables will need this to search a nested relationship which will require a 
		// //custom query to go with it. In that case, add a searchhandler value to direct FlexiGridController to your custom DB search function.
		// products: {
		// 	type: "products",
		// 	keyedby: "ProductID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection
		// 	searchkey: "Name", //This is the column we are searching from the table
		// 	//searchhandler:"ordersproducts",
		// 	value: [],
		// 	multiple: true,
		// 	//inputValue:"", //Text Search! This *CAN* be used... but seems nicer without it!
		// 	mode: "autocomplete",
		// 	orable: true,
		// 	defaultsearchterm: "70",
		// 	limit: 10, //Database return limit, keep below ~100
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// 	debouncetime: 0 //Not a lot of typing or results.
		// },
		// NotName: {
		// 	type: "NotName",
		// 	value: "",
		// 	mode: "not", //Nots may need to be added to FlexiGridSearchTools for non-orable.
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// //Standard DateTimeAfter
		// DateTimeAfter: {
		// 	type: "DateTimeAfter",
		// 	value: (() => {
		// 		//Set to 10 years ago (or else you probably won't get any data)
		// 		return dayjs().subtract(10, 'years');

		// 	})(),
		// 	mode: "datetimeafter",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// //Standard DateTimeBefore
		// DateTimeBefore: {
		// 	type: "DateTimeBefore",
		// 	value: dayjs(), //new Date, 
		// 	mode: "datetimebefore",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// //Example AutoComplete - Components can take optional "producttype" to narrow between product types.
		// components: {
		// 	type: "components",
		// 	keyedby: "ID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection
		// 	searchkey: "Name", //This is the column we are searching from the table
		// 	producttype: "Desktop",
		// 	value: [],
		// 	mode: "autocomplete",
		// 	orable: true,
		// 	defaultsearchterm: "",
		// 	limit: 10, //Database return limit, keep below ~100
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// 'Cost >': {
		// 	type: "Cost >",
		// 	value: "",
		// 	mode: "greaterthan",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// 'Cost <': {
		// 	type: "Cost <",
		// 	value: "",
		// 	mode: "lessthan",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// //Instead of Checkbox, this is Bool example. "yes, no, and - "
		// NewCheckbox: {
		// 	type: "NewCheckbox",
		// 	value: "",
		// 	mode: "bool",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// NameStrict: {
		// 	type: "Name",
		// 	value: "",
		// 	mode: "strict",
		// 	orable: false,
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	grow: 1,
		// },
		// SomeSelectable: {
		// 	type: "SomeSelectable",
		// 	value: [],
		// 	mode: "select",
		// 	orable: true,
		// 	//Select Menu Items:
		// 	menuitems: [
		// 		{
		// 			value: "",
		// 			key: uuidv4(),
		// 			text: "-",
		// 			usechip: false
		// 		},
		// 		{
		// 			value: 10,
		// 			key: uuidv4(),
		// 			text: "Ten (integer)",
		// 			usechip: false
		// 		},
		// 		{
		// 			value: "A",
		// 			key: uuidv4(),
		// 			text: "A",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Grade A",
		// 			chipclass: classes.gradea, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 		{
		// 			value: "B",
		// 			key: uuidv4(),
		// 			text: "B",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Grade B",
		// 			chipclass: classes.gradeb, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 		{
		// 			value: "C",
		// 			key: uuidv4(),
		// 			text: "C",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Grade C",
		// 			chipclass: classes.gradec, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 		{
		// 			value: "Bad",
		// 			key: uuidv4(),
		// 			text: "Bad",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Bad",
		// 			chipclass: classes.gradebad, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 		{
		// 			value: "Repair",
		// 			key: uuidv4(),
		// 			text: "Repair",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Repair",
		// 			chipclass: classes.graderepair, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 		{
		// 			value: "Scrap",
		// 			key: uuidv4(),
		// 			text: "Scrap",
		// 			//Optional usechip - Overrides text
		// 			usechip: true,
		// 			chipsize: "small",
		// 			chiplabel: "Scrap",
		// 			chipclass: classes.gradeb, //Test this.		
		// 			//Optional Chip Height and Centering:
		// 			height: "22px",
		// 			center: true,
		// 		},
		// 	],
		// 	uuid: uuidv4(),
		// 	container: containersizes,
		// 	keysize: keysizes,
		// 	//Experimental Multiple!
		// 	multiple: true,//Change 'value' to array if true.
		// 	center: true,
		// 	grow: 1,
		// 	usechips: true
		// },
	};

	/* ########################## Custom Parameters: Modify Per-Controller  ##########################

	 Each new table will likey have very different parameters. Handle them before configuration.

	Concept: We have this really complicated search input system. When a page is linked with URL parameters, let's marshall each 
	key-value pair into new defaults based on input defaults.

	Possibly clear the URL before rendering inputs and page?

				*/

	//This controls how many inputs we need to fill for the page. Often we simply use 4 or 8, but we'll try and modify the code to be able to use any values.
	const minimuminputs = 4;
	const maximuminputs = 8;		

	

	
	const params = new URLSearchParams(useLocation().search);

	const urlparams = Array.from(params.entries());


	//		AUTOCOMPLETEPAIRS
	//		If you are not using auto-complete search inputs, you may simply comment the array inside autocompletepairs.
	// 		This is a special array. It is structured to allow a key-value pair shortcut to pre-fill a search input with label!
	//		Logic below also removes the need to add the search input type - when an autocomplete pair is found our custom array's third argument allows us to understand the search input type!
	//		Database compatibility: Autocompletes are typically driven by the searchinputtype as well, see DBAutoComplete.php
	// 		URL Params Compatiblity: Any link generator will need to follow the pattern of the autocompletepair. In this example, ProductID then Name and always in that order.
	// 
	// 
	// 		The structure of the array of arrays is:
	//		----------------------------------------------------------------------------------------------------------------------------------------------------------------------
	//		keyedby: "ProductID", //We'll need a key so that Autocomplete can highlight our value in the drop down after selection. This is often how the DB will load the items.
	//		searchkey: "Name", //This is the column we are searching from the table, often a friendly name
	//		searchinputtype:  The searchinput that we're pre-filling. Having this assigned means we won't ever need to reference it as a URL parameter!
	//		[[keyedby, searchkey, searchinputtype],[keyedby, searchkey, searchinputtype],...]


	const autocompletepairs = [
		//['ProductID', 'Name', 'products'], //This will not only fetch from the DB correctly, but it will render the current value without a DB call!
		//['ProductID', 'Name', 'products']
		//DBKey, Named Item, Autocomplete System
		//More Entries...
	]

	const configuredinputs = []; //This is where we'll hold 
	var currentconfiguration = {}; 
	var combine = false;
	var simpleparam = true; //Values like OrderID, Name, Date.... no need for key-value input.
	//This itterates the parameters in sequential order. We need to have flags to check for pairs...
	for (let i = 0; i < urlparams.length; i++) {
		//Assume simpleparam until false:
		simpleparam = true;
		//console.log("Checking: "+urlparams[i][0]+"="+urlparams[i][1]);
		//With urlparams, 0 is the key, and 1 is the value.
		//Use current entry and check that it is or isn't an auto-complete pair
		for (let j=0; j<autocompletepairs.length; j++){
			if (urlparams[i][0]===autocompletepairs[j][0]){
				//Doublecheck for next value!
				if (urlparams[i+1] && urlparams[i+1][0]===autocompletepairs[j][1]){
					//console.log("Autocomplete Pair found: "+urlparams[i][0]+" and "+urlparams[i+1][0]);
					//Assume from here, we can digest the values and no longer process this as a simple parameter:
					simpleparam = false;
					currentconfiguration = Object.assign({}, inputdefaults[autocompletepairs[j][2]]); //Source must exist above. This example, we're cloning the 'products' search input.
					//This example is interpereted as : currentconfiguration = Object.assign({}, inputdefaults['products']);
					
					//Check if we should add our new configuration to an existing one.
					combine=false;
					for (var p=0;p<configuredinputs.length; p++){
						//console.log(configuredinputs);
						//console.log(currentconfiguration);
						if (configuredinputs[p].type===currentconfiguration.type){
							combine = true;
							//Modify existing configured input
							configuredinputs[p].value.push({
								[urlparams[i][0]]: urlparams[i][1],
								[urlparams[i + 1][0]]: urlparams[i + 1][1]
							})
						}
					}

					if (!combine){
						//Override value:
						currentconfiguration.value = [
							{
								[urlparams[i][0]]: urlparams[i][1],
								[urlparams[i + 1][0]]: urlparams[i + 1][1]
							}
						];
						//Push to configured inputs
						configuredinputs.push(currentconfiguration);
					}
					//console.log("Autocomplete found for: "+autocompletepairs[j][2]);
					//Since we consumed the second half of the URL parameter for the autocomplete, we skip the next URL entry!
					i++;
				}
			}
		}

		//If simpleparam is still true, we can handle it as a normal input:
		if (simpleparam){
			//Check that the parameter exists in inputdefaults:
			if (inputdefaults[urlparams[i][0]]){
				currentconfiguration = Object.assign({}, inputdefaults[urlparams[i][0]]);
				currentconfiguration.value = urlparams[i][1];
				//console.log(currentconfiguration);
				//Push to configured inputs
				configuredinputs.push(currentconfiguration);
			}
		}
	}

	//If configured inputs is less than the minimum, we need to fill the remainder with appropriately available search inputs, 
	//preset to commonly used ones that aren't already specified in URL parameters!
	//If we need a quick-start, simply set an array like ["Name","Name","Name","Name"] - we need enough to fill the minimum inputs required.
	//First we'll need a search input priority array:
	var priorityarray = [
		"Name",
		"SkuPrefix",
		"TotalInventoryUnits >",
		"StockOutDays30 >",

		"Status",
		"AverageAgeDays >",
		"AverageAgeDays <",
		"StockOutDays30 <",

		//I don't think it ever gets this far.
		"TotalInventoryUnits <",
		"TotalInventoryCost >",
		"TotalInventoryCost <",
		
	];

	//Make a copy of this array so we can use it for resets!
	var resetarray = Object.assign({}, priorityarray);

	var k=0;
	var l=0;
	var finalinputs=[]; //Configure a variable to send to configuration!
	if (configuredinputs.length < minimuminputs){
		for (var k=0; k<configuredinputs.length; k++){
			finalinputs.push(configuredinputs[k]);
			//Loop configured inputs and remove any priority items that are already handled!
			for (var m=0; m<priorityarray.length; m++){
				if (configuredinputs[k].type===priorityarray[m]){
					priorityarray.splice(m,1);
				}
			}
		}
	}

	//We can now itterate over the other priority inputs and fill in the next most important ones that weren't already sliced off the array.
	for (k=0; k<priorityarray.length; k++){
		finalinputs.push(inputdefaults[priorityarray[k]]);
	}
	//Debug:
	//console.log("Final Inputs:");
	//console.log(finalinputs);


	/* ##########################  Configuration Section  ########################## */
	//Perms - Be sure endpoints are secure because this certainly isn't. These are for perm driven views, not the perms on data.
	var perms = {
		createPerm:(userPerms['createProduct']===1 ? true : false),
		readPerm:(userPerms['readProduct']===1 ? true : false),
		updatePerm:(userPerms['updateProduct']===1 ? true : false),
		deletePerm:(userPerms['deleteProduct']===1 ? true : false),
	}



	//Grid Configuration
	const configuration = {
		//PAGE OPTIONS
		showtitle:true,
		title: "Products",
		menuitem:"/productsflexigrid",
		menusection:"Products",
		viewmode:"grid", //Default is "grid" to show grid mode. Can also be some other view, this controller will control that!
		defaulteditmode:true,
		 
		//DATA OPTIONS
		apiendpoint: "/flexigrid/",
		dbmodel:"flexproduct", //or flexproduct, flexorder, etc	
		itemskey:"ProductID", //Used as db key for updates and opening links
		nestedrelationships:[
			'creationuser', //CreatedByUserID
			'updateuser',	//UpdatedByUserID
			'deletionuser', //DeletedByUserID
			'productcomponents.details'
			//'product'
		],
		newitemviewurlprefix: "/product/", //When clicking 'ADD ITEM' button, goes to this url with the ID of created item.
		//Mutations: Useful for derived values such as FullName or TotalCharges. They are calculated client-side after data load and can be used for view or exports.
		//Fn or null.
		mutatedata:MutateData,
		exportmutatedata:ExportMutateData,


		//DB Support items (try to add supports to DB tables when it's helpful)
		softdeletesupport:true,
		creationusersupport:true,
		updateusersupport:true,
		deleteusersupport:true,

		//Datetimes to handle
		datetimes:[
			'created_at',
			'updated_at',
			//'DateTime',
		],


		//TABLE OPTIONS
		tablebordertype: "thin", //open (no borders like on Products), thin (Main tables, darker border), thick (Order Details has all thick and lighter gray border tables)
		showcolumnheaders:true,
		maxrowseditmode:100,
		statusbar:true,
		expandedrow:false,
		expandedrowrender:ExpandedRowRender, //Required function to be used inside bonus row <tr></tr> if ExpandRow=true
		minimuminputs:4,
		maximuminputs:8,
		rowsperpage:100,
		rowsperpageoptions:[100, 250, 500],



		//Search Input Settings
		//Check that each one of these coincides with a 'type' in inputdefaults 
		defaultselectinputs: [
			{ value: "Name", text: "Name" },
			{ value: "Status", text: "Status" },
			{ value: "SkuPrefix", text: "Sku Prefix" },
			{ value: "Mfg", text: "Manufacturer" },
			{ value: "ProductType", text: "Product Type" },
			{ value: "Touchscreen", text: "Touchscreen" },
			{ value: "TotalInventoryUnits >", text: "Inventory >" },
			{ value: "TotalInventoryUnits <", text: "Inventory <" },
			{ value: "Cost >", text: "Cost >" },
			{ value: "Cost <", text: "Cost <" },
			{ value: "TotalInventoryCost >", text: "Inventory Cost >" },
			{ value: "TotalInventoryCost <", text: "Inventory Cost <" },
			{ value: "Cost >", text: "Cost >" },
			{ value: "Cost <", text: "Cost <" },
			{ value: "AverageAgeDays >", text: "Age >" },
			{ value: "AverageAgeDays <", text: "Age <" },
			{ value: "StockOutDays30 >", text: "Stock Out Days >" },
			{ value: "StockOutDays30 <", text: "Stock Out Days <" },
			{ value: "RunDailyStats", text: "Run Stats" },
			
			// {
			// 	value: "products", text: "", html: () => {
			// 		return (
			// 			<span><span style={{ fontWeight: "bold", color: "green" }}>NEW</span> search by Products</span>
			// 		);
			// 	}
			// },
			// { value: "components", text: "Component" },
			// { value: "NewCheckbox", text: "Checkbox Bool" },
			// { value: "NameStrict", text: "Name Strict" },
			// { value: "SomeSelectable", text: "Some Selectable" }
		],
	

		//Keep a copy of the default inputs just in case the user wants to "reset" the page
		inputdefaults:inputdefaults, //ToDo: Change this to final inputs!
		resetarray:resetarray,
		//Send a copy of configuredinputs
		configuredinputs:finalinputs,

		//Search by & order
		orderby: "Name",
		order: "asc",


		/* ##########################  Columns Section  ########################## */
		//Columns describe the renderable columns
		//Header styles only respect width and not maxWidth or minWidth because tableLayout:"fixed" on flexigrid. Without fixed table layout, inner Grids won't ever size correctly.
		//Set these widiths carefully, and narrow on what you can.
		columns: [
			{
				field: "Checkbox",
				visible: true,
				columnheader: "maincheckbox",
				currentlyeditable:true,
				render: "maincheckbox", //Special, does not need extended config
				borders:"all",
				columnoption:false,
				columnoptionlabel:"Checkbox"

			},
			{
				field: "created_at",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Creation",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {width:"150px"}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "desc",
				editable: true,
				requiresref:false,
				render: "datetime",
				datetimeformat:"short", //"friendly",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Creation Date"
			},
			{
				field: "Name", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Name",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {width:"300px"}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:10, //Validation....
				render:"textlink", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				linkid:"ProductID",
				linkendpoint:"/product/",
				target:"_blank",
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Name"
			},
			{
				field: "Nav Inventory",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Inv",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: {width:"30px"}, //Raw inline css
				valuetextalign:"center", //This can help also anchor any children, even buttons
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				render: "customelement",
				customelement:NavInventory,
				borders:"noleft",
				columnoption:true,
				columnoptionlabel:"Nav Inventory"
			},
			{
				field: "Mfg", // or "key" or "name"
				visible: false,
				columnheader: "text",
				columnheadertext: "Manufacturer",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:128, //Validation....
				render:"text", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Manufacturer"
			},
			{
				field: "Cost",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Cost",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"70px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Cost"
			},
			{
				field: "ProductType",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Product Type",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "text",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Product Type"
			},
			{
				field: "ProductID", // or "key" or "name"
				visible: false,
				columnheader: "text",
				columnheadertext: "ID",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {width:"40px"}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:10, //Validation....
				render:"text", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Product ID"
			},
			{
				field: "Touchscreen",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Touch",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: {width:"70px"}, //Raw inline css
				valuetextalign:"center",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:true,
				validationmethod:"checkbox",
				render: "checkbox",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Touchscreen"
			},
			{
				field: "PartsLocation", // or "key" or "name"
				visible: true,
				columnheader: "text",
				columnheadertext: "Parts Loc",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				validationmethod:"text", // "text"....
				maxlength:128, //Validation....
				render:"text", // "textlink", Requires linkid (used as value in url), target, and linkendpoint
				borders:"all", 
				columnoption:true,
				columnoptionlabel:"Parts Location"
			},
			{
				field: "Components",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Default Components",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: {width:"500px"}, //Raw inline css
				valuetextalign:"left", //This can help also anchor any children, even buttons
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				render: "customelement",
				customelement:DefaultComponents,
				borders:"noleft",
				columnoption:true,
				columnoptionlabel:"Default Components"
			},
			{
				field: "TurnoverRating",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Rating",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"70px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"1",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Turnover Rating"
			},
			{
				field: "TotalInventoryCost",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Total Cost",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"90px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Total Cost"
			},
			{
				field: "TotalInventoryUnits",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Units",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"40px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"1",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Total Units"
			},
			{
				field: "AverageAgeDays",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Age",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"60px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"1",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Average Age in Days"
			},
			{
				field: "AverageCostActual",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Avg Cost",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"80px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"1",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Average Unit Cost"
			},
			{
				field: "StockOutDays30",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Stock Out Days",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"100px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"1",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Stock Out Days"
			},
			{
				field: "OneYrSalesTotal",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "1Yr Sales $",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"100px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"1",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"1 Year Sales Total"
			},
			{
				field: "OneYrSalesUnits",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "1Yr Sales Units",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"100px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"1",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"1 Year Sales Units"
			},
			{
				field: "PercentOfInventoryCost",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "% Inv Cost",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"100px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Percent of Inventory Cost"
			},
			{
				field: "PercentOfInventoryUnits",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "% Inv Units",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"100px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Percent of Inventory Units"
			},
			{
				field: "Grades",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Grades",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: {}, //Raw inline css
				valuetextalign:"center", //This can help also anchor any children, even buttons
				allowsort: false,
				defaultsortorder: "asc",
				editable: false,
				requiresref:false,
				render: "customelement",
				customelement:Grades,
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Grades Chart"
			},
			{
				field: "GradeAPct",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "A %",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"60px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Units Grade A %"
			},
			{
				field: "GradeBPct",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "B %",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"60px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Units Grade B %"
			},
			{
				field: "GradeCPct",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "C %",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"60px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Units Grade C %"
			},
			{
				field: "GradeRepairPct",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Repair %",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"65px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Units Grade Repair %"
			},
			{
				field: "GradeScrapPct",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Scrap %",
				columnheaderalign: "right", //left, right, center
				columnheaderstyle: {width:"65px"}, //Raw inline css
				valuetextalign:"right",
				allowsort: true,
				defaultsortorder: "desc",
				editable: false,
				requiresref:false,
				validationmethod:"positivedecimal2", // "text", "positivedecimal2"
				render: "number",
				step:"0.01",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Units Grade Scrap %"
			},
			{
				field: "Status",
				visible: true,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Status",
				columnheaderalign: "left", //left, right, center
				columnheaderstyle: {width:"120px"}, //Raw inline css
				valuetextalign:"left",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:false,
				validationmethod:"select",
				render: "select", //Requires Selections:
				selectoptions:[
					{value:"Unknown", text:"Unknown", useCustomOption:true, customOption:()=>{return <MenuItem value={"Unknown"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#808080", padding:"2px 5px 0px 5px"}}>Unknown</div></MenuItem>;}},
					{value:"Stalled", text:"Stalled", useCustomOption:true, customOption:()=>{return <MenuItem value={"Stalled"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#b23f3f", padding:"2px 5px 0px 5px"}}>Stalled</div></MenuItem>;}},
					{value:"Needs Work", text:"Needs Work", useCustomOption:true, customOption:()=>{return <MenuItem value={"Needs Work"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#CE823E", padding:"2px 5px 0px 5px"}}>Needs Work</div></MenuItem>;}},
					{value:"OK", text:"OK", useCustomOption:true, customOption:()=>{return <MenuItem value={"OK"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#45B84A", padding:"2px 5px 0px 5px"}}>OK</div></MenuItem>;}},
					{value:"Closeout \ Sold Out", text:"Closeout \ Sold Out", useCustomOption:true, customOption:()=>{return <MenuItem value={"Closeout \ Sold Out"}><div style={{borderRadius:"5px", color:"#FFF", backgroundColor:"#CCB136", padding:"2px 5px 0px 5px"}}>Closeout \ Sold Out</div></MenuItem>;}},
				],
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Status"
			},
			{
				field: "RunDailyStats",
				visible: false,
				columnheader: "text", //Requires columnheadertext and allowsort
				columnheadertext: "Run Stats",
				columnheaderalign: "center", //left, right, center
				columnheaderstyle: {width:"70px"}, //Raw inline css
				valuetextalign:"center",
				allowsort: true,
				defaultsortorder: "asc",
				editable: true,
				requiresref:true,
				render: "checkbox",
				borders:"all",
				columnoption:true,
				columnoptionlabel:"Run Stats Checkbox"
			},
			

		],

		//Controls how edit mode will traverse editable cells.
		taborder:["PartsLocation"],

		// buttonsold:{
		// 	Save:{
		// 		visible:true
		// 	},
		// 	PendingSave:{
		// 		visible:true
		// 	},
		// 	AddRow:{
		// 		visible:true
		// 	},
		// 	AddItem:{
		// 		visible:true
		// 	},
		// 	ViewOptions:{
		// 		visible:true
		// 	}
		// }

		/* ##########################  Buttons Section  ########################## */
		buttons: [
			{
				type:"Save",
				text:"Save",
				visible:true,
				perm:(userPerms['updateProduct']===1 ? true : false)
			},{
				type:"PendingSave",
				text:"Save",
				visible:true,
				perm:(userPerms['updateProduct']===1 ? true : false)
			},{
				type:"AddRow",
				text:"Add Row",
				visible:false,
				perm:(userPerms['createProduct']===1 ? true : false)
			},{
				type:"AddItem",
				text:"Add Product",
				visible:true,
				perm:(userPerms['createProduct']===1 ? true : false)
			},{
				type:"ViewOptions",
				text:"View Options",
				visible:true,
				perm:true,
				config:{
					expandsearch:true,
					expandall:false,
					editmode:false
				}
			},{
				type:"EditItems",
				text:"Edit Items",
				visible:true,
				perm:(userPerms['bulkEditProduct']===1 ? true : false)
			},{
				type:"Export",
				text:"Export",
				visible:false,
				perm:true
			},{
				type:"ItemList",
				text:"Item List",
				visible:false,
				perm:true,
				title:"Item List",
				description: "Filter grid results by item <Name, ID, Sku, etc>.",
				itemlistkey:"Name"
			},{
				type:"Reset",
				text:"Reset",
				visible:true,
				perm:true
			},
			// SPECIAL PURPOSE BUTTONS, YOU MAY CONFIGURE THESE FOR YOUR NEEDS INCLUDING FUNCTIONS!
			// Name them as such: CustomButton1, CustomButton2, etc.
			{
				type:"CustomButton1",
				text:"A Custom Btn",
				visible:false,
				perm:true,
				icon:<RestartAltIcon sx={{
					color: "#222", fontSize: "1.2em", // match text size
					verticalAlign: "middle", // helps on some browsers
					display: "inline-block",
				}}>
				</RestartAltIcon>,
				customfunction: SelectSomeBoolean
			}
		],

		bulkeditcolumns: [
			{
				field:"RunDailyStats", 
				label:"Run Statistics",
				changetype:"select",
				menuitems:
				[
					{
						value:0,
						label:"No"
					},{
						value:1,
						label:"Yes"
					}
				],
				default:{
					value:0,
					label:"No"
				},
			},
			{
				field:"Touchscreen", 
				label:"Has Touchscreen",
				changetype:"select",
				menuitems:
				[
					{
						value:0,
						label:"No"
					},{
						value:1,
						label:"Yes"
					}
				],
				default:{
					value:0,
					label:"No"
				},
			},
			{
				field:"PartsLocation",
				label:"Parts Location",
				changetype:"text",
				maxlength:128,
				minlength:2
			},
			{
				field:"DeleteItems",
				label:"Delete Items",
				changetype:"deleteitems"
			}

		],

		exportoptions:{
			limit:10000,
			exportmessage: "Exports of search results will be limited to your selection or the first "+10000+" rows of your current search.",
			filename:"BasicTableCSV",
			columns: [
				{ column: "ID", label: "ID" },
				{ column: "Name", label: "Name" },
				{ column: "ProductID", label: "ProductID" },
				{ column: "product.Name", label: "Product Name" },
				{ column: "Cost", label: "Cost"},
				{ column: "Price", label: "Price"},
				{ column: "Margin", label: "Margin"},
				{ column: "NewMargin", label: "NewMargin"},
				{ column: "NewNewMargin", label: "NewNewMargin"},
				{ column: "PositiveInteger", label: "PositiveInteger"},
				{ column: "SomeBoolean", label: "SomeBoolean"},
				{ column: "NewCheckbox", label: "NewCheckbox"},
				{ column: "DateTime", label: "Date", dateFormat: "YYYY-MM-DD HH:mm"},
			],

			exporttypes:[
				{label:"Simple",
					removevalues:[
						'ID'
					]
				}
			]
		}
	}





	/* 
				░█████████                               ░██                     
				░██     ░██                              ░██                     
				░██     ░██  ░███████  ░████████   ░████████  ░███████  ░██░████ 
				░█████████  ░██    ░██ ░██    ░██ ░██    ░██ ░██    ░██ ░███     
				░██   ░██   ░█████████ ░██    ░██ ░██    ░██ ░█████████ ░██      
				░██    ░██  ░██        ░██    ░██ ░██   ░███ ░██        ░██      
				░██     ░██  ░███████  ░██    ░██  ░█████░██  ░███████  ░██                                                                                                                 
	*/

	return (<FlexiGrid configuration={configuration} classes={classes} perms={perms}/>);
}

export default ProductsFlexiGrid;